/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { FormattedMessage } from 'react-intl';
import { emailLoginConfigs } from 'config';
import AuthenticateButton from 'components/ChoreoSystem/Authenticate/AuthenticateButton/AuthenticateButton';
import { ReactComponent as GithubIcon } from 'components/ChoreoSystem/Images/Brands/Github.svg';

interface GithubLoginButtonProps {
  onClick: () => void;
}

export default function GithubLoginButton(props: GithubLoginButtonProps) {
  const { onClick } = props;

  const ButtonText = () => {
    if (emailLoginConfigs.ENABLE_EMAIL_LOGIN === 'true') {
      return (
        <FormattedMessage
          id="modules.login.buttons.githubLoginButton.githubLoginButton.continue.withGithub"
          defaultMessage="Continue with GitHub"
        />
      );
    }
    return (
      <FormattedMessage
        id="modules.login.buttons.githubLoginButton.githubLoginButton.signIn.withGithub"
        defaultMessage="Sign in with GitHub"
      />
    );
  };

  return (
    <AuthenticateButton
      testId="github-sign-in"
      onClick={onClick}
      startIcon={<GithubIcon fontSize="inherit" />}
    >
      {ButtonText()}
    </AuthenticateButton>
  );
}
